import React from "react";

export default function DuplicateApplicationDialog({ isOpen, applicationData, onClose, onViewStatus }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: "1rem",
        animation: "fadeIn 0.2s ease-out",
      }}
      onClick={onClose}
    >
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
          @keyframes slideUp {
            from {
              transform: translateY(20px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "2rem",
          maxWidth: "500px",
          width: "100%",
          maxHeight: "80vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          animation: "slideUp 0.3s ease-out",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #dbeafe, #3b82f6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 1rem",
              fontSize: "2rem",
            }}
          >
            ℹ️
          </div>
          <h3
            style={{
              margin: 0,
              color: "#1e40af",
              fontSize: "1.5rem",
              fontWeight: "700",
            }}
          >
            Application Already Exists
          </h3>
          <p
            style={{
              margin: "0.5rem 0 0",
              color: "#64748b",
              fontSize: "0.95rem",
            }}
          >
            You have already submitted a passport application
          </p>
        </div>

        {/* Application Details */}
        {applicationData && (
          <div
            style={{
              background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
              borderRadius: "12px",
              padding: "1.25rem",
              marginBottom: "1.5rem",
              border: "1px solid rgba(59, 130, 246, 0.2)",
            }}
          >
            <div style={{ marginBottom: "0.75rem" }}>
              <span
                style={{
                  fontSize: "0.8rem",
                  color: "#64748b",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                Application Reference
              </span>
              <p
                style={{
                  margin: "0.25rem 0 0",
                  fontSize: "1.1rem",
                  fontWeight: "700",
                  color: "#1e40af",
                  fontFamily: "monospace",
                }}
              >
                {applicationData.referenceNumber || "N/A"}
              </p>
            </div>

            {applicationData.submittedDate && (
              <div style={{ marginBottom: "0.75rem" }}>
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  Submitted On
                </span>
                <p
                  style={{
                    margin: "0.25rem 0 0",
                    fontSize: "0.95rem",
                    color: "#334155",
                  }}
                >
                  {new Date(applicationData.submittedDate).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }
                  )}
                </p>
              </div>
            )}

            {applicationData.status && (
              <div>
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  Status
                </span>
                <p
                  style={{
                    margin: "0.25rem 0 0",
                    fontSize: "0.95rem",
                    color: "#334155",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      padding: "4px 12px",
                      borderRadius: "999px",
                      background:
                        applicationData.status === "Approved"
                          ? "rgba(34, 197, 94, 0.1)"
                          : applicationData.status === "Pending"
                          ? "rgba(234, 179, 8, 0.1)"
                          : "rgba(59, 130, 246, 0.1)",
                      color:
                        applicationData.status === "Approved"
                          ? "#15803d"
                          : applicationData.status === "Pending"
                          ? "#a16207"
                          : "#1e40af",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                    }}
                  >
                    {applicationData.status}
                  </span>
                </p>
              </div>
            )}
          </div>
        )}

        {/* Information Message */}
        <div
          style={{
            background: "#fef3c7",
            borderRadius: "12px",
            padding: "1rem",
            marginBottom: "1.5rem",
            border: "1px solid rgba(245, 158, 11, 0.2)",
          }}
        >
          <p
            style={{
              margin: 0,
              color: "#92400e",
              fontSize: "0.9rem",
              lineHeight: "1.5",
            }}
          >
            You cannot submit a new application while an existing application is
            in progress. Please check your application status or contact support
            if you need assistance.
          </p>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: "flex",
            gap: "0.75rem",
            flexDirection: "column",
          }}
        >
          {onViewStatus && (
            <button
              type="button"
              onClick={onViewStatus}
              style={{
                width: "100%",
                padding: "0.75rem 1rem",
                borderRadius: "10px",
                border: "none",
                background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
                color: "white",
                fontSize: "1rem",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.02)";
                e.currentTarget.style.boxShadow =
                  "0 6px 16px rgba(59, 130, 246, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(59, 130, 246, 0.3)";
              }}
            >
              View Application Status
            </button>
          )}

          <button
            type="button"
            onClick={onClose}
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              background: "white",
              color: "#475569",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#f8fafc";
              e.currentTarget.style.borderColor = "#94a3b8";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "white";
              e.currentTarget.style.borderColor = "#cbd5e1";
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}